var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'chartPie':true,'hot':_vm.typeArr.indexOf(_vm.type) > -1},attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }